(() => {
  function normalize(root) {
    const banners = Array.from(root.querySelectorAll('.ofk-product-payments'));
    if (!banners.length) return;
    const buttons = Array.from(root.querySelectorAll('form[action*="/cart/add"] [data-add-to-cart]'));
    const button = buttons.find(item => item.getClientRects().length) || buttons[0];
    if (!button) return;
    const form = button.closest('form');
    const banner = banners.find(item => item.closest('form') === form) || banners[0];
    banners.forEach(item => { if (item !== banner) item.remove(); });
    if (button.nextElementSibling !== banner) button.after(banner);
  }
  let queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    requestAnimationFrame(() => {
      queued = false;
      document.querySelectorAll('.product-section').forEach(normalize);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  ['page:loaded', 'shopify:section:load', 'quickview:loaded', 'quickview:open'].forEach(event => document.addEventListener(event, schedule));
  window.addEventListener('resize', schedule);
  new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(node => node.nodeType === 1 && (node.matches('.ofk-product-payments, .product-section, [data-add-to-cart]') || node.querySelector('.ofk-product-payments, .product-section, [data-add-to-cart]'))))) schedule();
  }).observe(document.body, { childList: true, subtree: true });
})();